import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { AppThunk } from '../store'
import {
  getCompany,
  getContract,
  patchCompany,
  postContract,
} from '../../apis/setting'
import { setErrors } from '../common/errorsSlice'
import {
  Company,
  CompanyInfo,
  EditCompanyRequest,
  getContractRequest,
  getContractResponse,
  postContractRequest,
} from '../../types/setting'

export interface CompanyState extends Company {
  isLoading: boolean
}

const initialState: Partial<CompanyState> = {
  isLoading: true,
}

const companySlice = createSlice({
  name: 'company',
  initialState,
  reducers: {
    requestStart: (state) => {
      state.isLoading = true
      return state
    },
    getCompanySuccess: (state, action: PayloadAction<Company>) => {
      // eslint-disable-next-line no-param-reassign
      state = { ...state, ...action.payload }
      state.isLoading = false
      return state
    },
    patchCompanySuccess: (state, action: PayloadAction<CompanyInfo>) => {
      // eslint-disable-next-line no-param-reassign
      state = { ...state, ...action.payload }
      state.isLoading = false
      return state
    },
    requestFailure: (state) => {
      state.isLoading = false
      return state
    },
  },
})

export const {
  requestStart,
  getCompanySuccess,
  patchCompanySuccess,
  requestFailure,
} = companySlice.actions

export const companyReducer = companySlice.reducer

export const fetchCompany = (
): AppThunk => async (dispatch) => {
  dispatch(requestStart())
  getCompany()
    .then((result) => dispatch(getCompanySuccess(result)))
    .catch((error) => {
      dispatch(requestFailure())
      dispatch(setErrors(error))
    })
}

export const updateCompany = (
  params: EditCompanyRequest,
  callback: () => void,
): AppThunk => async (dispatch) => {
  dispatch(requestStart())
  patchCompany(params)
    .then((result) => {
      dispatch(patchCompanySuccess(result))
      callback()
    })
    .catch((error) => {
      dispatch(requestFailure())
      dispatch(setErrors(error))
    })
}

export const fetchContract = (
  params: getContractRequest,
  callback: (result: getContractResponse) => void,
  errorCallback: () => void,
): AppThunk => async (dispatch) => {
  getContract(params)
    .then((result: getContractResponse) => {
      callback(result)
    })
    .catch((error) => {
      dispatch(requestFailure())
      dispatch(setErrors(error))
      errorCallback()
    })
}

export const updateContract = (
  params: postContractRequest,
  callback: () => void,
  errorCallback: () => void,
): AppThunk => async (dispatch) => {
  postContract(params)
    .then(() => {
      callback()
    })
    .catch((error) => {
      dispatch(requestFailure())
      dispatch(setErrors(error))
      errorCallback()
    })
}
